"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_1 = require("../node");
const deserialize_1 = require("../util/deserialize");
class FilterGroupNode extends node_1.default {
    static from(obj) {
        if (obj['type'] === 'filter-group')
            return new FilterGroupNode(obj['filters'].map(deserialize_1.deserializeNode), obj['groupType']);
        return null;
    }
    constructor(filters, groupType) {
        super('Filter Group Node');
        this.filters = filters;
        this.groupType = groupType;
    }
    checkPort(portNumber) {
        return portNumber === 0;
    }
    getSignature(datasetRepo) {
        if (!this.incoming[0])
            return null;
        return this.incoming[0].getSignature(datasetRepo);
    }
    validate(datasetRepo, incoming) {
        if (!incoming)
            incoming = this.incoming[0];
        if (!incoming)
            return false;
        // Note, that the incoming node is validated within the following call.
        return this.filters.every(f => f.validate(datasetRepo, incoming));
    }
    serialize() {
        return super.serialize({
            type: 'filter-group',
            filters: this.filters.map(f => f.serialize()),
            groupType: this.groupType,
        });
    }
}
exports.default = FilterGroupNode;
